import { useEffect, useState } from "react";
import { supabase } from "@/lib/supabase";
import { useBookingSettings } from "@/lib/booking";
import { Card, Field, Area, SaveBtn, Ok, Err, SubTitle, Notice, useAction } from "./adminUI";
import { useQueryClient } from "@tanstack/react-query";

const KEYS = ["deposit_pct", "hold_minutes", "service_fee_pct", "service_fee_fixed", "min_advance_hours", "max_installments", "business_hours", "booking_rules"];
const NUM = ["deposit_pct", "hold_minutes", "service_fee_pct", "service_fee_fixed", "min_advance_hours", "max_installments"];

export default function BookingRulesAdmin() {
    const settings = useBookingSettings();
    const qc = useQueryClient();
    const [f, setF] = useState(settings);
    const { run, busy, msg, err } = useAction();
    useEffect(() => { setF(settings); }, [settings.updated_at]); // eslint-disable-line react-hooks/exhaustive-deps
    const set = (k) => (v) => setF((o) => ({ ...o, [k]: v }));

    const save = () => run(async () => {
        const patch = Object.fromEntries(KEYS.map((k) => [k, NUM.includes(k) ? Number(f[k]) || 0 : f[k]]));
        const r = await supabase.from("booking_settings").update({ ...patch, updated_at: new Date().toISOString() }).eq("id", 1);
        qc.invalidateQueries({ queryKey: ["booking-settings"] });
        return r;
    });

    return (
        <Card className="space-y-4">
            <SubTitle>Regras de reserva, sinal e taxas</SubTitle>
            <div className="grid gap-4 sm:grid-cols-3" data-testid="booking-rules-admin">
                <Field label="Sinal padrão (%) — referência" type="number" value={f.deposit_pct} onChange={set("deposit_pct")} testid="rules-deposit" />
                <Field label="Taxa de serviço (%)" type="number" value={f.service_fee_pct ?? 0} onChange={set("service_fee_pct")} testid="rules-fee-pct" />
                <Field label="Taxa fixa por reserva (R$)" type="number" value={f.service_fee_fixed ?? 0} onChange={set("service_fee_fixed")} testid="rules-fee-fixed" />
                <Field label="Antecedência mínima (horas)" type="number" value={f.min_advance_hours ?? 2} onChange={set("min_advance_hours")} />
                <Field label="Bloqueio temporário da vaga (min)" type="number" value={f.hold_minutes} onChange={set("hold_minutes")} />
                <Field label="Parcelas máximas (se o provedor permitir)" type="number" value={f.max_installments ?? 1} onChange={set("max_installments")} />
            </div>
            <p className="text-sm text-dim" data-testid="rules-payment-method">Forma de pagamento preparada: <strong>Pix pelo Mercado Pago</strong>. Cartão, boleto e dinheiro no embarque não estão habilitados para novas cobranças.</p>
            <Area label="Horários de atendimento" value={f.business_hours} onChange={set("business_hours")} />
            <Area label="Regras gerais de reserva" value={f.booking_rules} onChange={set("booking_rules")} />
            <Notice tone="amber" testid="rules-online-payment">
                Pagamento online: <strong>{settings.online_payment_enabled ? "ativo" : "desativado"}</strong>. A liberação do Pix pelo Mercado Pago depende das credenciais da conta responsável, dos testes e da aprovação das políticas. Até lá, as reservas seguem como solicitação e confirmação pela equipe.
            </Notice>
            <div className="flex items-center justify-end gap-3"><Ok msg={msg} /><Err msg={err} /><SaveBtn onClick={save} saving={busy} testid="rules-save" /></div>
        </Card>
    );
}
